import React from 'react';
import styled from 'styled-components';
import logo from '../assets/logo.png';

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.sidebar ? '8px' : '20px'};
  width: 100%;
  min-width: min-content;

  .logo-intelliverse {
    width: auto;
    height: ${props => props.sidebar ? '48px' : '72px'};
    transition: all 0.3s ease;
    animation: floatPulse 5s ease-in-out infinite;
    margin-bottom: ${props => props.sidebar ? '2px' : '10px'}; /* Reducido de 10px a 2px solo en sidebar para acercar al título */
    /* filter: drop-shadow(0 0 6px #00B9AEaa); */ /* Eliminado el glow como se solicitó */
  }

  .title-container {
    display: ${props => props.sidebar ? 'none' : 'flex'};
    flex-direction: column;
    align-items: center;
    margin-top: 1.25rem;
    width: fit-content;
    min-width: min-content;
  }

  h1 {
    font-size: clamp(2rem, 4vw, 3.5rem);
    line-height: 1;
    font-weight: 600; /* Cambiado de 900 a 600 (semi-bold) para coincidir con la imagen */
    font-family: 'Orbitron', monospace;
    white-space: nowrap;
    text-align: center;
    color: rgba(255, 255, 255, 0.95); /* Blanco suave sin saturación */
    letter-spacing: 1px; /* Espaciado entre letras como en la imagen */
    /* text-shadow eliminado completamente */
    /* filter eliminado completamente */
    /* box-shadow eliminado completamente */
  }

  @media (max-width: 768px) {
    .logo-intelliverse {
      height: ${props => props.sidebar ? '32px' : '56px'};
    }
  }

  @keyframes floatPulse {
    0% { transform: translateY(0px) scale(1); opacity: 1; }
    50% { transform: translateY(-2px) scale(1.05); opacity: 1; }
    100% { transform: translateY(0px) scale(1); opacity: 1; }
  }
`;

const Logo = ({ sidebar = false, className = '' }) => {
  return (
    <LogoContainer sidebar={sidebar} className={className}>
      <img 
        src={logo}
        alt="IntelliVerseOne"
        className="logo-intelliverse"
      />
      <div className="title-container">
        <h1>IntelliVerseOne</h1>
      </div>
    </LogoContainer>
  );
};

export default Logo; 